import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    productBatches: [],
    productBatch: null,
    filteredProductBatches: [],
    balance: 0,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null,
    isUpdating: false
};

export default function productBatchReducer(state = initialState, action) {

    var newState;
    switch (action.type) {
        case Constants.REQUEST_ADD_PRODUCT_BATCH:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.REQUEST_UPDATE_PRODUCT_BATCH:
            newState = { ...state };
            newState.isUpdating = true;
            return newState;

        case Constants.SUCCESS_UPDATE_PRODUCT_BATCH:
            newState = { ...state };
            newState.isUpdating = false;
            newState.isUpdated = true;
            newState.productBatches = newState.productBatches.filter(a => a.id !== action.id);
            return newState;

        case Constants.FAILED_UPDATE_PRODUCT_BATCH:
            newState = { ...state };
            newState.isUpdating = false;
            newState.isUpdated = false;
            newState.error = action.error;
            return newState;

        case Constants.SUCCESS_ADD_PRODUCT_BATCH:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.SUCCESS_FILTERED_PRODUCTS_BATCHES:
            newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredProducts = action.filteredProducts;
            return newState;

        case Constants.FAILED_ADD_PRODUCT_BATCH:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;


        case Constants.REQUEST_GET_PRODUCTS_BATCHES:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = true;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredProducts = action.filteredProducts;
            return newState;

        case Constants.SUCCESS_GET_PRODUCTS_BATCH:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            if (action.productBatches) {
                newState.productBatches = action.productBatches.items;
                newState.page = action.productBatches.page;
                newState.pageSize = action.productBatches.pageSize;
                newState.count = action.productBatches.totalCount;
            }
            if (action.balance) {
                newState.balance = action.balance;
            }

            return newState;

        case Constants.FAILED_GET_PRODUCTS_BATCHES:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;
        default:
            if (state.error) {
                newState = { ...state };
                newState.error = null;

                return newState;
            }

            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ProductBatcheReducer.js